

//Servidor Produccionhttps://news.google.com/
// export let CONFIG = {
//     Settings: {
//         CASLOGIN: 'https://seguridad.espoch.edu.ec/cas/login?',
//         CASLOGOUT: 'https://seguridad.espoch.edu.ec/cas/logout?',
//         CASVALIDATE: 'https://seguridad.espoch.edu.ec/cas/p3/serviceValidate?',
//         REDIRECT_URI: 'https://hcenteno.espoch.edu.ec:5205/ingreso',
//         LOGOUT_REDIRECT: 'https://becas.espoch.edu.ec/logout/',
//         LOGOUT_CORREO: 'https://login.microsoftonline.com/common/oauth2/logout?',
//         VALIDATEJAVA: 'https://servicioscomprobante.espoch.edu.ec/ServicioWebComprobantes/ServiciosComprobantes/ValidateCas/'
//     }
// };

// // //Servidor Produccion
export let CONFIG = {
    Settings: {
        CASLOGIN: 'https://seguridad.espoch.edu.ec/cas/login?',
        CASLOGOUT: 'https://seguridad.espoch.edu.ec/cas/logout?',
        CASVALIDATE: 'https://seguridad.espoch.edu.ec/cas/p3/serviceValidate?',
        REDIRECT_URI: 'https://becas.espoch.edu.ec/ingreso',
        LOGOUT_REDIRECT: 'https://becas.espoch.edu.ec/logout/',
        LOGOUT_CORREO: 'https://login.microsoftonline.com/common/oauth2/logout?',
        VALIDATEJAVA:'https://servicioscomprobante.espoch.edu.ec/ServicioWebComprobantes/ServiciosComprobantes/ValidateCas/'
    }
};
